import { createAction } from 'redux-actions';
import { reduxKey } from '../../constants';
// Dynamic redux
export const reduxModuleLoaded = createAction(`${reduxKey}.REDUX_READY`, ()=>({}));
export const init = createAction(`${reduxKey}.GRUSERPAGE.INIT`, (payload)=>payload);
